import React from 'react';
import styles from './InfoCard.module.scss';

// eslint-disable-next-line react/prop-types
function InfoCard({ value: { pursued_from = '', instution = '', grade = '', degree = '', year = '', company = '', location = '', experience = '' } }) {
  return (
    <div className={styles.infoContainer}>
      <span className={styles.pursuedYearTag}>{pursued_from || year}</span>
      <h3>{degree || company}</h3>
      <span  className={styles.instutiteName}>{instution || location}</span>
      {(grade || experience) && <span className={styles.grade}>{grade ? 'Grade:' : 'Years of Experience: ' } <span className={styles.gradeValue}>{grade || experience}</span></span> }
    </div>
  );
}

export default InfoCard;
